import { render, staticRenderFns } from "./view-more.vue?vue&type=template&id=4d26c46a&scoped=true"
import script from "./view-more.vue?vue&type=script&lang=ts"
export * from "./view-more.vue?vue&type=script&lang=ts"
import style0 from "./view-more.vue?vue&type=style&index=0&id=4d26c46a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d26c46a",
  null
  
)

export default component.exports